import React from 'react';
import { BackgroundGridSC } from './background-grid.styled';
import invariant from 'invariant';
import { setHours } from 'date-fns';
import { WCS } from '../../week-utils';
import { ObservedSize, TWeekStart } from '../../../calendars';
import DayProgress from './day-progress';
import Grid from './grid';

interface BackgroundGridProps {
  cellHeight?: number;
  minHour?: number;
  maxHour?: number;
  style?: React.CSSProperties;
  showDayProgress?: boolean;
  calendarDims?: ObservedSize;
  weekStartDate?: string;
  weekStartsOn?: TWeekStart;
  setHourY?: (y: number) => void;
}

const BackgroundGrid: React.FunctionComponent<BackgroundGridProps> = ({
  cellHeight = WCS.cellHeight,
  minHour = 0,
  maxHour = 24,
  style,
  showDayProgress,
  calendarDims,
  weekStartDate,
  weekStartsOn,
  setHourY,
}) => {
  const range = maxHour - minHour;
  const startHour = setHours(Date.now(), minHour);

  invariant(range > 0, 'Range must be positive');

  return (
    <BackgroundGridSC
      cellHeight={cellHeight}
      style={{ ...style, height: cellHeight * range + WCS.gridPadding }}
    >
      <Grid startHour={startHour} range={range} setHourY={setHourY} />
      {showDayProgress ? (
        <DayProgress
          maxHour={maxHour}
          minHour={minHour}
          calendarDims={calendarDims}
          weekStartDate={weekStartDate as string}
          weekStartsOn={weekStartsOn as TWeekStart}
        />
      ) : null}
    </BackgroundGridSC>
  );
};

export default React.memo(BackgroundGrid);
